import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Offers from "./components/Offers";
import Services from "./components/Services";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Faq from "./components/Faq";
import FloatingButtons from "./components/FloatingButtons";

// Service Pages
import WarehousingPage from "./components/Services/WarehousingPage.js";
import AirCargoPage from "./components/Services/AirCargoPage.js";
import SeaCargoPage from "./components/Services/SeaCargoPage";
import InsurancePage from "./components/Services/InsurancePage";
import CustomsPage from "./components/Services/CustomPage";
import LogisticsPage from "./components/Services/LogisticsPage";
import Testimonials from "./components/Testimonials";

import "./App.css";

function ScrollToHash() {
  const { hash, pathname } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    const id = hash.replace("#", "");
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [hash, pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <Navbar />
      <FloatingButtons />
      <ScrollToHash />
      <Routes>
        {/* Main Landing Page */}
        <Route
          path="/"
          element={
            <>
              <Hero />
              <Offers />
              <Services />
              <Faq />
              <Testimonials />
              <About />
              <Contact />
              <Footer />
            </>
          }
        />

        {/* Service Pages */}
        <Route path="/warehousing" element={<WarehousingPage />} />
        <Route path="/aircargo" element={<AirCargoPage />} />
        <Route path="/seacargo" element={<SeaCargoPage />} />
        <Route path="/insurance" element={<InsurancePage />} />
        <Route path="/customs" element={<CustomsPage />} />
        <Route path="/logistics" element={<LogisticsPage />} />
        <Route path="/testimonials" element={<Testimonials />} />
      </Routes>
    </Router>
  );
}

export default App;
